import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";
import { waLink, generalMsg, WHATSAPP_PRETTY } from "@/lib/whatsapp";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-obsidian">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8 lg:pt-24">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-400">
              Ropa deportiva urbana Nike y Adidas. Del gym a la calle, directo desde Buenos Aires a tu puerta.
            </p>
            <a
              href={waLink(generalMsg())}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-button"
              className="mt-6 inline-flex items-center gap-2 bg-wa px-5 py-3 font-display text-sm font-black uppercase tracking-widest text-black transition-colors hover:bg-[#20bd5a]"
            >
              <MessageCircle className="h-4 w-4" /> {WHATSAPP_PRETTY}
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-widest text-volt">Secciones</p>
            <ul className="mt-5 space-y-3">
              {[["Inicio", "/"], ["Catálogo completo", "/tienda"]].map(([label, to]) => (
                <li key={label}>
                  <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="group inline-flex items-center gap-1 text-sm text-zinc-400 transition-colors hover:text-white">
                    {label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-widest text-volt">Pagos y envíos</p>
            <ul className="mt-5 space-y-3 text-sm text-zinc-400">
              <li>Mercado Pago — tarjetas, dinero en cuenta y cuotas</li>
              <li>Efectivo y transferencia coordinando por WhatsApp</li>
              <li>Envíos a todo Buenos Aires (CABA y GBA) en 24–48h</li>
              <li>10% OFF en tu segunda prenda</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
          <p className="text-stroke whitespace-nowrap text-center font-display text-[18vw] font-black uppercase leading-none tracking-tight lg:text-[13rem]">
            MM Store
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 font-mono text-[11px] uppercase tracking-widest text-zinc-600 sm:flex-row">
          <p>© {new Date().getFullYear()} MM Store — Buenos Aires, Argentina</p>
          <p>Del gym a la calle</p>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-volt">
            Administración
          </Link>
        </div>
      </div>
    </footer>
  );
}
